import { authedApiFetch } from '../../../utils/Api';

/**
 * Service for handling monitor alerts configuration
 */
const monitorAlertsService = {
  /**
   * Fetch all monitor source types with their configurations
   * @param {string} tenantId - The tenant ID
   * @returns {Promise<Array>} - Array of monitor source type configurations
   */
  getMonitorSourceTypes: async (tenantId) => {
    const response = await authedApiFetch({
      endpoint: `/tenants/${tenantId}/config_lists?list_type=monitor_source_types`,
      method: 'GET',
    });
    
    // Return the first item's config_list_items if available, or empty array
    return response?.[0]?.config_list_items || [];
  },

  /**
   * Update a monitor source type configuration
   * @param {string} tenantId - The tenant ID
   * @param {string} configListId - The config list ID
   * @param {string} itemId - The config list item ID
   * @param {Object} updates - The updates to apply
   * @returns {Promise<Object>} - Updated monitor configuration
   */
  updateMonitorSourceType: async (tenantId, configListId, itemId, updates) => {
    const response = await authedApiFetch({
      endpoint: `/tenants/${tenantId}/config_lists/${configListId}/config_list_items/${itemId}`,
      method: 'PATCH',
      payload: { config_list_item: updates },
    });
    return response;
  },

  /**
   * Get available refresh cadences
   * @param {string} tenantId - The tenant ID
   * @returns {Promise<Array>} - Array of refresh cadence options
   */
  getRefreshCadences: async (tenantId) => {
    const response = await authedApiFetch({
      endpoint: `/tenants/${tenantId}/config_lists?list_type=refresh_cadences`,
      method: 'GET',
    });
    
    return response?.[0]?.config_list_items || [];
  },
};

export default monitorAlertsService;
